import { ORDER_METHODS, PaymentMethods } from '../../../../../../services/exports/Constants';

export default {
  title: 'Metody płatności',
  fields: {
    hidden_payment_methods: {
      label: 'Ukryte metody płatności',
    },
    has_online_payments: {
      label: 'Płatności online',
    },
    has_paypal_upcharge: {
      label: 'Dopłata 3,5% za transakcje PayPal',
    },
    has_cash_payments: {
      label: 'Płatności gotówkowe',
    },
    has_occ_cash_payments: {
      label: 'Płatności gotówkowe Call Center włączone',
    },
    has_in_store_card_payments: {
      label: 'Płatności kartą w lokalu',
    },
    overwrite_cash_payments_to_invoice: {
      label: 'Oznacz płatności gotówkowe jako „Faktura"',
    },
  },
  payment_methods: {
    [PaymentMethods.CARD]: 'Karta',
    [PaymentMethods.PAYPAL]: 'PayPal',
    [PaymentMethods.APPLE_PAY]: 'Apple Pay',
    [PaymentMethods.GOOGLE_PAY]: 'GPay',
    [PaymentMethods.SOFORT]: 'Sofort',
    [PaymentMethods.IDEAL]: 'iDEAL | Wero',
    [PaymentMethods.BANCONTACT]: 'Bancontact',
    [PaymentMethods.EPS]: 'EPS',
    [PaymentMethods.P24]: 'Przelewy24',
    [PaymentMethods.BLIK]: 'BLIK',
    [PaymentMethods.TWINT]: 'TWINT',
    [PaymentMethods.VENMO]: 'Venmo',
    [PaymentMethods.WERO]: 'Wero',
    [PaymentMethods.KLARNA]: 'Klarna',
    [PaymentMethods.TRUSTLY]: 'Trustly',
    [PaymentMethods.PIX]: 'Pix',
    [PaymentMethods.NUPAY]: 'NuPay',
    [PaymentMethods.GIROPAY]: 'Giropay',
    [PaymentMethods.SEPA_DEBIT]: 'Polecenie zapłaty SEPA',
    [PaymentMethods.CASH]: 'Gotówka',
    [PaymentMethods.BACS_DEBIT]: 'Polecenie zapłaty BACS',
    [PaymentMethods.PAY_BY_BANK]: 'Płatność przez bank',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Odbiór osobisty',
    [ORDER_METHODS.delivery]: 'Dostawa',
    [ORDER_METHODS.room_service]: 'Obsługa pokoju/stolika',
  },
  modals: {
    confirmation: {
      title: 'Czy na pewno?',
      description:
        'Po potwierdzeniu płatności online będą <strong>{{onlineState}}</strong>, płatności gotówkowe będą <strong>{{cashState}}</strong>',
    },
  },
  labels: {
    off: 'wyłączone',
    on: 'włączone',
  },
  buttons: {
    save: 'Zapisz',
    configure_online_payments: 'Skonfiguruj płatności online',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
